module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 42
// module chunks = 0